import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import '@/App.css';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { CategoryGrid } from './components/CategoryGrid';
import { SustainabilitySection } from './components/SustainabilitySection';
import { ManufacturingSection } from './components/ManufacturingSection';
import { WhyChooseUsSection } from './components/WhyChooseUsSection';
import { RequestQuoteModal } from './components/RequestQuoteModal';
import { Footer } from './components/Footer';
import { CollectionPage } from './components/CollectionPage';
import { ContactPage } from './components/ContactPage';
import { AboutPage } from './components/AboutPage';
import { WholesalePage } from './components/WholesalePage';
import { SustainabilityPage } from './components/SustainabilityPage';

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => setIsQuoteModalOpen(true);
  const closeQuoteModal = () => setIsQuoteModalOpen(false);

  return (
    <div className="App min-h-screen bg-[#F5F2ED]" data-testid="app-container">
      <Navbar onRequestQuote={openQuoteModal} />

      <main>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HeroSection onRequestQuote={openQuoteModal} />
                <CategoryGrid />
                <WhyChooseUsSection />
                <SustainabilitySection onRequestQuote={openQuoteModal} />
                <ManufacturingSection onRequestQuote={openQuoteModal} />
              </>
            }
          />
          <Route
            path="/collection"
            element={<CollectionPage onRequestQuote={openQuoteModal} />}
          />
          <Route
            path="/contact"
            element={<ContactPage onRequestQuote={openQuoteModal} />}
          />
          <Route
            path="/about"
            element={<AboutPage onRequestQuote={openQuoteModal} />}
          />
          <Route
            path="/wholesale"
            element={<WholesalePage onRequestQuote={openQuoteModal} />}
          />
          <Route
            path="/sustainability"
            element={<SustainabilityPage onRequestQuote={openQuoteModal} />}
          />
          <Route
            path="*"
            element={
              <>
                <HeroSection onRequestQuote={openQuoteModal} />
                <CategoryGrid />
                <WhyChooseUsSection />
                <SustainabilitySection onRequestQuote={openQuoteModal} />
                <ManufacturingSection onRequestQuote={openQuoteModal} />
              </>
            }
          />
        </Routes>
      </main>

      <Footer />

      <RequestQuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </div>
  );
}

export default App;
